import { render, staticRenderFns } from "./CostTable.vue?vue&type=template&id=5f81f37b&scoped=true"
import script from "./CostTable.vue?vue&type=script&lang=js"
export * from "./CostTable.vue?vue&type=script&lang=js"
import style0 from "./CostTable.vue?vue&type=style&index=0&id=5f81f37b&prod&lang=scss&scoped=true"
import style1 from "./CostTable.vue?vue&type=style&index=1&id=5f81f37b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f81f37b",
  null
  
)

export default component.exports